import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { currentDateFormat } from "../../utils";
import SaveButton from "../../components/buttons/SaveButton";
import CancelButton from "../../components/buttons/CancelButton";
import { DevTool } from "@hookform/devtools";
import { UPDATE_AGENCY, GET_STATE_URI, VIEW_AGENCY_EDIT } from "../../constant";
import ConfirmPassword from "../../components/ConfirmPassword";
//import Swal from '../../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from "../../messageBox/customSweetAlert";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/loaderAction";
import Loader from "../../components/loader/Loader";

function AgencyEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [stateData, setStateData] = useState([]);
  const [actualValue, setActualValue] = useState([]);
  const [agencyDetails, setAgencyDetails] = useState();
  const inputRef = useRef("");
  var newNumber = "";
  const [randomNumber, setRandomNumber] = useState(newNumber);
  const {
    register,
    handleSubmit,
    control,
    formState,
    getValues,
    reset,
    setValue,
    watch,
  } = useForm({ defaultValues: { agency_id: randomNumber } });
  const { errors } = formState;
  const onSubmit = async (data) => {
    //console.log('chk data:', data.password);
    if (data.password === "*******") {
      data.password = actualValue;
    }
    data.id = id;
    console.log("Form data:", data);
    //return false;
    try {
      dispatch(setLoading(true));
      const response = await axios.post(UPDATE_AGENCY, data);
      if (response.data.status === "200") {
        dispatch(setLoading(false));
        Swal.fire({
          title: "Success!",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        dispatch(setLoading(false));
        Swal.fire({
          title: "Error!",
          text: response.data.message,
          icon: "Error",
          confirmButtonText: "OK",
        });
      }
      //console.log('response:', response);
    } catch (error) {
      dispatch(setLoading(false));
      console.error("Error logging in:", error);
    }
  };
  useEffect(() => {
    // fetch user ID from API or storage
    const loadUser = async () => {
      dispatch(setLoading(true));
      const response_state = await axios.get(GET_STATE_URI);
      console.log("response_state::",response_state.data);
      const response = await axios.get(VIEW_AGENCY_EDIT + "/" + `${id}`);
      setStateData(response_state.data);
      setAgencyDetails(response.data?.data);
      setRandomNumber(response.data?.data?.agency_id);
      // if(response.data.login_password){
      //   setActualValue(response.data.login_password);
      //   setValue ('password','*******');
      //   setValue ('confirmPassword','*******');
      // }
      reset({
        agency_name: response.data?.data?.full_name,
        address_1: response.data?.data?.address1,
        city: response.data?.data?.city,
        state: response.data?.data?.state,
        zip: response.data?.data?.zip,
        email: response.data?.data?.user_email,
        agency_id: response.data?.data?.agency_id,
        u_nme: response.data?.data?.login_user_name,
        is_active: response.data?.data?.is_admin_driver === 1 ? 1 : 0,
        enable_dhs:
          response.data?.data?.feature?.isDHS_FTP_enabled === 1 ? 1 : 0,
      });
      dispatch(setLoading(false));
    };

    loadUser();
    //console.log(data);
  }, []);

  useEffect(() => {
    if (!agencyDetails || stateData.length === 0) return;

    const matchingState = stateData.find(
      (state) =>
        String(state.state_id) === String(agencyDetails.state) ||
        state.state_name === agencyDetails.state
    );

    if (matchingState) {
      setValue("state", String(matchingState.state_id));
    }
  }, [agencyDetails, stateData, setValue]);

  const handleCancelClick = () => {
    navigate("/home/agency/list", { replace: true }); // redirect to /list route
  };

  return (
    <>
      <div
        className="tab-pane fade active show"
        id="add-passenger"
        role="tabpanel"
        aria-labelledby="home-tab"
      >
        <section>
          <div className="d-flex justify-content-between form-container">
            <div>
              <h2 className="fs-5 font-weight-600"> Add Agency</h2>
            </div>
            <div>
              <span>{currentDateFormat(currentDate)}</span>
            </div>
          </div>
        </section>
        <section>
          <div className="bg-white  px-5 py-4">
            <div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-items">
                  <div>
                    <label className="require-field">Agency Name</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="preferred_name"
                      {...register("agency_name", {
                        required: {
                          value: true,
                          message: "Agency Name is required",
                        },
                      })}
                    />
                    <p className="errors">
                      {errors && errors.agency_name?.message}
                    </p>
                  </div>

                  <div>
                    <label className="require-field">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="address_line_one"
                      {...register("address_1", {
                        required: {
                          value: true,
                          message: "Address is required",
                        },
                      })}
                    />
                    <p className="errors">
                      {errors && errors.address_1?.message}
                    </p>
                  </div>

                  <div>
                    <label className="require-field">City</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="city"
                      {...register("city", {
                        required: {
                          value: true,
                          message: "City is required",
                        },
                      })}
                    />
                    <p className="errors">{errors && errors.city?.message}</p>
                  </div>
                  <div>
                    <label className="require-field">State</label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="state"
                      {...register("state")}
                    >
                      <option value="">Select</option>
                      {stateData.map((state, index) => (
                        <option key={index} value={String(state.state_id)}>
                          {state.state_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="require-field">Zip</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="zip"
                      {...register("zip", {
                        required: {
                          value: true,
                          message: "Zip is required",
                        },
                      })}
                      onChange={(event) => {
                        const value = event.target.value;
                        event.target.value = value
                          .replace(/[^0-9]/g, "")
                          .substring(0, 5);
                      }}
                    />
                    <p className="errors">{errors && errors.zip?.message}</p>
                  </div>
                  <div className="form-item">
                    <label className="require-field">Email Address</label>
                    <input
                      type="text"
                      className="form-control"
                      autoComplete="off"
                      id="email_address"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email",
                        },
                      })}
                    />
                    <p className="errors">{errors && errors.email?.message}</p>
                  </div>
                  <div className="row">
                    <div className="form-group col-sm-3 col-4 item">
                      <label className="require-field">Company Id</label>
                      <input
                        type="text"
                        className="form-control"
                        ref={inputRef}
                        value={randomNumber}
                        id="agency_id"
                        {...register("agency_id", {
                          defaultValue: randomNumber,
                        })}
                        disabled={true}
                      />
                    </div>

                    {/* <div
                      className="form-group col-sm-3  col-8 item"
                      style={{ float: "right" }}
                    >
                      <label>&nbsp;</label>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="is_active"
                          checked={
                            watch("is_active") === 1 ||
                            watch("is_active") === true
                          }
                          {...register("is_active")}
                        />
                        <label className="form-check-label" htmlFor="is_active">
                          Mark as Active
                        </label>
                      </div>
                    </div> */}

                    <div className="form-check col-sm-3 col-8 item">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="is_active"
                        checked={
                          watch("is_active") === 1 ||
                          watch("is_active") === true
                        }
                        {...register("is_active")}
                      />
                      <label className="form-check-label" for="checkDefault">
                        Mark as Driver
                      </label>
                    </div>
                  </div>
                </div>
                <div className="my-4">
                  <p className="sub-title">User Details</p>
                  <div className="form-item">
                    <ConfirmPassword
                      register={register}
                      getValues={getValues}
                      errors={errors}
                      isEditMode="1"
                    />
                  </div>
                </div>
                <div className="form-check col-sm-3 col-8 item">
                  <p className="sub-title ">Feature</p>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="enable_dhs"
                      checked={
                        watch("enable_dhs") === 1 ||
                        watch("enable_dhs") === true
                      }
                      {...register("enable_dhs")}
                    />
                    <label className="form-check-label" for="checkDefault">
                      Enable DHS  
                    </label>
                  </div>
                </div>
                <div className="footer-content">
                  <SaveButton type="submit" buttonTitle={"UPDATE AGENCY"} />
                  <CancelButton
                    cancelHandler={() =>
                      navigate("/home/agency/list", { replace: true })
                    }
                  />
                </div>
              </form>
              <DevTool control={control} />
            </div>
          </div>
        </section>
      </div>
      <div>{loading && <Loader />}</div>
    </>
  );
}

export default AgencyEdit;
